<template>
<table class="ui celled striped table">
  <tbody>
    <tr v-for="(form, i) in replyTemplateForms" :key="i">
      <td>
        <form class="ui form" :class="{'warning': form.hasErrors()}">
          <div class="field">
            <div class="required field">
              <label>テンプレート名</label>
              <input type="text" v-model="form.model.name">
              <validation-message :form="form" field="name"></validation-message>
            </div>
          </div>
          <div class="field">
            <div class="required field">
              <label>メッセージ</label>
              <textarea rows="5" v-model="form.model.message"></textarea>
              <validation-message :form="form" field="message"></validation-message>
            </div>
          </div>
          <validation-message :form="form" field="template_max"></validation-message>
        </form>
      </td>
      <td class="actions">
        <button type="button" class="ui tiny positive button" @click="saveReplyTemplate(form)">保存</button>
        <button type="button" class="ui tiny red button" @click="deleteReplyTemplate(form, i)">削除</button>
      </td>
    </tr>
  </tbody>
  <tfoot v-if="replyTemplateForms.length < 3" class="full-width">
    <th colspan="2">
      <div class="ui center aligned">
        <i class="clickable plus green large icon" @click="newReplyTemplate()"></i>
      </div>
    </th>
  </tfoot>
</table>
</template>

<script>
export default {
    data: function() {
        return {
            model: {},
            replyTemplateForms: [],
            form: this.createForm(),
        };
    },
    created: function() {
        this.form.get('/shopadmin/api/reply_templates', function(response) {
            this.replyTemplateForms = response.data.map(function(replyTemplate) {
                return this.createForm(replyTemplate);
            }.bind(this));
        }.bind(this));
    },
    methods: {
        newReplyTemplate: function() {
            if (this.replyTemplateForms.length < 3) {
                this.replyTemplateForms.push(this.createForm());
            }
        },
        saveReplyTemplate: function(form) {
            if (form.model.id) {
                form.put(form.model.detail_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            } else {
                form.post('/shopadmin/api/reply_templates', function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            }
        },
        deleteReplyTemplate: function(form, i) {
            if (!form.model.id) {
                this.replyTemplateForms.splice(i, 1);
                return;
            }
            if (!confirm('削除します。よろしいですか？')) {
                return;
            }
            form.delete(form.model.detail_api_url, function() {
                this.replyTemplateForms.splice(i, 1);
            }.bind(this));
        },
    }
};
</script>
